import { CSSProperties, FC, ReactNode } from 'react'
import classNames from 'classnames'
import { Spin } from 'antd'
import { LoadingOutlined } from '@ant-design/icons'
import cn from './index.module.css'

export interface ISecondaryButton {
  children: ReactNode | string
  disabled?: boolean
  className?: string
  styles?: CSSProperties
  isLoading?: boolean
  onClick: () => void
}

const SecondaryButton: FC<ISecondaryButton> = ({
  children,
  disabled,
  className,
  styles,
  isLoading,
  onClick,
}) => {
  return (
    <button
      className={classNames(cn.button, className)}
      disabled={disabled ?? isLoading}
      onClick={onClick}
      style={styles}
    >
      <Spin
        className={classNames(isLoading && cn.showLoading, cn.loadingIcon)}
        indicator={
          //@ts-ignore
          <LoadingOutlined
            spin
          />
        }
      />
      {children}
    </button>
  )
}

export default SecondaryButton
